(() => {
  const warningText = document.currentScript?.dataset.headMismatch || '';
  function init() {
    const syncDetails = details => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', String(details.open));
    };
    document.querySelectorAll('details').forEach(syncDetails);
    document.addEventListener('toggle', event => {
      if (event.target instanceof HTMLDetailsElement) syncDetails(event.target);
    }, true);
    let lastAge;
    let selectedHead;
    let timer;
    function syncHead() {
      const age = document.querySelector('variant-selects input[name="Edad"]:checked')?.value;
      const head = document.querySelector('product-info-upsell[data-handle="replacement-brush-head"] select');
      if (!age || !head) return;
      if (age !== lastAge) {
        selectedHead = age;
        lastAge = age;
      }
      if (head.value !== selectedHead && [...head.options].some(option => option.value === selectedHead)) {
        head.value = selectedHead;
        head.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const container = head.closest('product-info-upsell');
      let warning = container.querySelector('[data-bz-head-warning]');
      if (!warning) {
        warning = document.createElement('p');
        warning.dataset.bzHeadWarning = '';
        warning.setAttribute('role', 'status');
        warning.style.cssText = 'font-size:1.3rem;line-height:1.4;margin:8px 0;';
        warning.textContent = warningText;
        const anchor = head.closest('.select') || head;
        anchor.insertAdjacentElement('afterend', warning);
      }
      warning.hidden = head.value === age;
    }
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(syncHead, 80);
    }
    document.addEventListener('change', event => {
      if (event.target.matches('product-info-upsell[data-handle="replacement-brush-head"] select')) selectedHead = event.target.value;
      schedule();
    });
    const product = document.querySelector('product-info');
    if (product) new MutationObserver(schedule).observe(product, { childList: true, subtree: true });
    syncHead();
    setTimeout(syncHead, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
